import * as React from "react";

// Honeybadger disabled: this app is retired, replaced by vino-storefront-next.
// Commented rather than deleted so it can be restored if this build is revived.
//
// Dropping the boundary is behaviour-neutral here: the only mount point
// (gatsby-browser.js) never passed an ErrorComponent, so the default rendered
// null on error — the same blank result as having no boundary at all.
//
// import { Honeybadger, HoneybadgerErrorBoundary } from "@honeybadger-io/react";
//
// const baseHoneyBadgerConfig = {
//   apiKey: process.env.GATSBY_HONEYBADGER_API_KEY,
//   environment: `${process.env.GATSBY_VM_ENV}[${process.env.GATSBY_VM_MARKET}]`,
//   developmentEnvironments: ["development"],
//   reportData: process.env.GATSBY_VM_ENV === "production",
//   filters: ["password", "creditcard"],
// };
//
// const standardConfig = {
//   enableUncaught: false,
//   maxErrors: 5,
// };
//
// // Uncaught handlers and the error cap are browser-only concerns.
// const honeyBadgerConfig =
//   typeof window === "undefined"
//     ? baseHoneyBadgerConfig
//     : { ...baseHoneyBadgerConfig, ...standardConfig };
//
// const isProd = process.env.NODE_ENV !== "development";
// const EmptyComponent = () => null;

const ErrorNotifierProvider = ({
  children,
}: {
  children?: React.ReactNode;
}): JSX.Element => {
  return <>{children}</>;

  // return (
  //   <>
  //     {isProd ? (
  //       <HoneybadgerErrorBoundary
  //         honeybadger={isProd ? Honeybadger.configure(honeyBadgerConfig) : null}
  //         ErrorComponent={ErrorComponent}
  //       >
  //         {children}
  //       </HoneybadgerErrorBoundary>
  //     ) : (
  //       children
  //     )}
  //   </>
  // );
};

export default ErrorNotifierProvider;
